import { useState } from "react";
import { ChevronDown } from "lucide-react";
import BlockShell from "./BlockShell";

const DayCard = ({ day, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-[#E2E0DC] rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 bg-[#F9F8F6] hover:bg-[#F0EDE8] text-left"
      >
        <span className="font-semibold text-[#1A1A1A]">{day.label || day.date}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="divide-y divide-[#E2E0DC] bg-white">
          {(day.entries || []).map((e, i) => (
            <li key={i} className="px-5 py-3 flex items-start gap-3">
              <span className="font-mono text-xs text-[#E76F51] w-16 shrink-0 pt-0.5">{e.time}</span>
              <div className="flex-1">
                <p className="text-[#1A1A1A] font-medium m-0">
                  {e.link ? <a href={e.link} target="_blank" rel="noopener noreferrer" className="underline decoration-[#E76F51]/40 underline-offset-2 hover:decoration-[#E76F51]">{e.act}</a> : e.act}
                </p>
                {e.venue && <p className="text-xs text-[#5C5C5C] m-0">{e.venue}</p>}
              </div>
            </li>
          ))}
          {(day.entries || []).length === 0 && (
            <li className="px-5 py-4 text-sm italic text-[#5C5C5C]">Schedule TBA</li>
          )}
        </ul>
      )}
    </div>
  );
};

const ScheduleBlock = ({ block }) => {
  const cfg = block.config || {};
  const days = cfg.days || [];
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-schedule">
      <BlockShell block={block}>
        <div className="space-y-3">
          {days.map((d, i) => (
            <DayCard key={i} day={d} defaultOpen={i === 0} />
          ))}
          {days.length === 0 && (
            <p className="text-sm italic text-[#5C5C5C]">No schedule uploaded yet — add rows or upload a CSV.</p>
          )}
        </div>
      </BlockShell>
    </section>
  );
};

export default ScheduleBlock;
